export enum EventStatus {

  Pending = 0,
  PartecipationAccepted = 1,
  PartecipationRejected = 2,
  Cancelled = 3

}
